@if (loading) {
<bracelit-preloader
  style="height: 100%; display: flex; justify-content: center; align-items: center;"></bracelit-preloader>
}

<div style="display: flex; flex-direction: row; flex-wrap: wrap;">
  @if (!loading) {
  <div
    style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: center; justify-content: center;">
    <div class="voucher-title bold-20px-center-primary primary-border-100"
      style="position:relative; width:100% !important;display: flex; align-items: center; justify-content: space-between !important; border-bottom:none; margin: 15px 0;">
      <div class="close_container" style="position: absolute; right: 0;" (click)="onClose()">
        <div class="close"></div>
      </div>
    </div>
    <div class="voucher-title bold-20px-center-marine primary-border-100"
      style="width:100% !important;display: flex; align-items: center; justify-content: center !important; border-bottom:none; margin-top: 15px">
      {{voucherBlueprint ? voucherBlueprint.name : voucher.name}}
    </div>
    @if (voucher) {
    <div
      style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: flex-start; margin-top: 12px">
      <div class="voucher-text-row light-16px-center-marine"
        style="display: flex; align-items: center; flex-direction:row; margin-top:10px; margin-bottom:10px">
        @if (voucher) {
        <ng-container>
          <div class="secondary-background-full circulo"></div>
          {{leftLabel}} {{voucher.usesLeft|number: '1.2-2'}} {{tokensLabel2}}
        </ng-container>
        }
      </div>
      @if (voucher) {
      <div style="background-color:#C0C4CA; width: 100% !important; height:1px !important; margin: 0px 12px 0px 12px">
      </div>
      }
      <div class="voucher-text-row light-16px-center-marine"
        style="display: flex; align-items: center; flex-direction:row; margin-top:10px; margin-bottom:10px">
        @if (voucher) {
        <ng-container>
          <div class="secondary-background-empty circulo"></div>
          {{leftLabel2}} {{gastado|number: '1.2-2'}} {{tokensLabel2}}
        </ng-container>
        }
      </div>
      @if (voucher) {
      <div style="background-color:#C0C4CA; width: 100% !important; height:1px !important; margin: 0px 12px 0px 12px">
      </div>
      }

      @if (voucherBlueprint) {
      <ng-container>
        @if (voucherBlueprint.moneyExtra > 0) {
        <div class="voucher-text-row voucher-text-margin light-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center; margin-top: 20px">
          {{messageMoneyExtra}}
        </div>
        }
        @if (voucherBlueprint.moneyExtra > 0) {
        <div class="voucher-text-row bold-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center;">
          {{voucherBlueprint.moneyExtra | number: '1.0-2'}} €
        </div>
        }

        @if (voucherBlueprint.uses > 0 && voucher.usesLeft <= voucherBlueprint.uses) { <div
          class="voucher-text-row voucher-text-margin bold-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center; margin-top: 20px">
          Total {{tokenLabel2}}s: {{voucherBlueprint.uses}}
    </div>
    }
    @if (voucherBlueprint.uses > 0 && voucher.usesLeft > voucherBlueprint.uses) {
    <div class="voucher-text-row voucher-text-margin bold-16px-center-marine"
      style="width: 100%; display: flex; align-items: center; justify-content: center; margin-top: 20px">
      Total {{tokenLabel2}}s: {{voucher.usesLeft * voucherBlueprint.uses}}
    </div>
    }
    </ng-container>
    }
  </div>
  }
  <div>
    @if ((voucherBlueprint !== undefined) && (voucherBlueprint.description !== null)) {
    <div class="voucher-text-row voucher-text-margin light-16px-center-marine" id="desc"
      [innerHTML]="voucherBlueprint.description">
    </div>
    }
    <div style="display: flex; flex-direction: column;">
      @if ((voucherBlueprint !== undefined) && (voucherBlueprint.preSaleOfferStart !== null) &&
      (voucherBlueprint.preSaleOffer !== null)) {
      <div style="display: flex; flex-direction: column; margin: 12px 0;">
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; font-weight: bold !important; display: flex; align-items: center; justify-content: center;">
          {{buyInterval}}</div>
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center;">
          {{start}}: {{voucherBlueprint.preSaleOfferStart}}
        </div>
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center;">
          {{end}}: {{voucherBlueprint.preSaleOffer}}
        </div>
      </div>
      }
      @if ((voucherBlueprint !== undefined) && (voucherBlueprint.startingDate !== '2000-01-01 00:00:00') &&
      (voucherBlueprint.endingDate !== '3000-01-01 00:00:00')) {
      <div style="display: flex; flex-direction: column; margin: 12px 0;">
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; font-weight: bold !important; display: flex; align-items: center; justify-content: center;">
          {{useInterval}}</div>
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center;">
          {{start}}: {{voucherBlueprint.startingDate}}
        </div>
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; display: flex; align-items: center; justify-content: center;">
          {{end}}: {{voucherBlueprint.endingDate}}
        </div>
      </div>
      }
      @if ((voucherBlueprint !== undefined) && (voucherBlueprint.maximumToSell !== null)) {
      <div style="display: flex; flex-direction: column; margin: 12px 0;">
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; font-weight: bold !important; display: flex; align-items: center; justify-content: center;">
          {{maximumToSellText}}: {{voucherBlueprint.maximumToSell}}
        </div>
      </div>
      }
      @if ((voucherBlueprint !== undefined) && (voucherBlueprint.maximumTimesToRecharge !== null)) {
      <div style="display: flex; flex-direction: column; margin: 12px 0;">
        <div class="voucher-text-row light-16px-center-marine"
          style="width: 100%; font-weight: bold !important; display: flex; align-items: center; justify-content: center;">
          {{maximumTimesToRechargeText}}: {{voucherBlueprint.maximumTimesToRecharge}}
        </div>
      </div>
      }
    </div>
  </div>
</div>
}